export default {
  "learn-more": "了解更多",
  "read-more": "阅读全文",
  home:{
    title1:'聚焦顽疾',
    title2:'为不可能寻找答案',
    label1: '地中海贫血症',
    label2: '帕金森病',
    label3: '血友病',
    label4: '艾滋病',
    learnMore: '了解更多',
    title3: '',
    title4: '精于每个细节',
    label5: '领先技术',
    label6: '精尖管线',
    label7: '高效生产',
    label8: '资深团队',
    title5: '大道多助',
    title6: '合作创造未来',
    label9: '科技引领，携手突破医疗边界',
    newsTitle: '新闻中心',
    readAll: '阅读全文'
  },
  footer:{

  },

  aboutkl: {
    label1: '关于康霖',
    btn1: '公司介绍',
    btn2: '发展历程',
    btn3: '管理团队',
    btn4: '合作单位',
    label2: '康霖生物科技（杭州）有限公司是一家以做首创药物（First-in-Class）和同类最优（Best-in-Class）创新基因药物为目标的国家级高新技术企业。秉承为患者做好药的初心，康霖始终贯彻以技术突破为导向，为患者为自己创造价值的使命与愿景，针对临床痛点研发新药。',
    label3: '针对的领域多为严重影响人类健康的疾病，如艾滋病、帕金森病、血友病和地中海贫血症等。康霖的战略目前已初见成效，在多个方面技术水平已达到国际领先，其中艾滋病功能性治愈项目获得了国家科技重大专项和浙江省重点研发项目支持，地中海贫血症项目的临床试验效果远优于国际同行。',
    label4: '自主创新',
    label5: '基因治疗',
    label6: '功能性治愈',
  

  },
  "about-team1-txt1": "吴昊泉  博士",
  "about-team1-txt2": "创始人 CEO",
  "about-team1-txt4": "｜原美国洛杉矶希望之城贝克曼研究所教授",
  "about-team1-exp1-t1": "主要学习和工作经历 ",
  "about-team1-exp1": "复旦大学 博士及研究助理 ",
  "about-team1-exp2": "UCLA 博士后",
  "about-team1-exp3": "哈佛大学 博士后",
  "about-team1-exp4": "德州理工 Tenure track 助理教授",
  "about-team1-exp5": "德州理工 副教授兼康霖生物CEO ",
  "about-team1-exp6": "希望之城 教授兼康霖生物CEO",
  "about-team1-exp7-1": "至今",
  "about-team1-exp7": "康霖生物 CEO ",
  "about-team1-exp1-t2-1": "发表论文30多篇，被引用次数超过",
  "about-team1-exp1-t2-2": "5000次",
  "about-team1-exp1-t3": "浙江省海外高层次人才、杭州市521计划人才等",
  "about-team1-exp1-t4-1": "以负责人（PI）身份获得6项美国NIH基金、1项美国NSF基金",
  "about-team1-exp1-t4-2": "主持和参与了1项国家科技重大专项项目和1项省重点研发项目",

  "about-team2-txt1": "杨涤非 博士",
  "about-team2-txt3": "COO & CFO",
  "about-team2-txt4": "｜ 前瑞穗银行董事总经理、25年海外药企经营和投资管理",
  "about-team2-txt5": "｜前CDE主审、石药大分子药开发副总，正高级工程师",

  "about-team2-exp1-t1-1": "1991年毕业于北京大学，1996年在UCLA获得化学博士学位，并于1999年在美国佐治亚州立大学获得MBA学位",
  "about-team2-exp1-t1-2": "共发表论文九篇，获得专利五项",
  "about-team2-exp1-t1-3": "拥有近30年研发、项目管理、产品商业化、BD、企业并购以及华尔街投资经验",
  "about-team2-exp1-t2": "有13年跨国医药公司和医疗器械公司工作经验，先后在苏威（现被艾伯维收购）、碧迪等公司担任要职，曾主持过一项13亿欧元医药公司的收购，以及领导多国工程师实现医疗器械产品全球生产质量标准化等",
  "about-team2-exp1-t3": "近十几年杨博士在华尔街从事医药投资业务，负责的投资研究领域涵盖多种疾病（神经系统、肿瘤、消化道、皮肤、新陈代谢及罕见病）和多种技术路线（大分子、小分子、细胞治疗）",
  "about-team2-exp1-t4": "曾担任日本瑞穗银行董事总经理，主管美国医药投资业务",
  "about-team2-exp1-t5": "对美国的医药上市批准、定价以及医保系统有深度了解，熟悉新药开发的回报与风险",

  "about-team3-txt1": "刘伯宁 博士",
  "about-team3-txt4": "康霖生物CTO，教授级正高级工程师",
  "about-team3-exp1-t1": "华南理工大学生物化学与分子生物学博士。刘博士有近20年的生物技术药物开发与评价行业经验",
  "about-team3-exp1-t2": "曾长期就职华北制药新药研发中心（抗体药物研制国家重点实验室，2006-2013），完成国内首个抗狂犬病毒奥木替韦单抗注射液的工艺开发等",
  "about-team3-exp1-t3": "曾就职上海张江生物技术有限公司（抗体药物与靶向治疗国家重点实验室,2013-2015），完成国内首个多免疫靶点双抗分子",
  "about-team3-exp1-t4": "曾就职国家药监局药品审评中心（2015-2019）任药学主审，完成国内首批生物类似药、PD-1单抗以及CAR-T产品的上市（或申报临床）技术审评",
  "about-team3-exp1-t5": "主笔撰写多个生物制品药学评价技术指导原则",
  "about-team3-exp1-t6": "曾任石药集团巨石生物制药有限公司副总经理（2019-2022），负责石药集团大分子产品管线搭建与项目实施，以及子公司巨石生物制药公司日常运营管理等工作",
  "about-team3-exp1-t7": "完成新药研发所、工艺开发所、分析与制剂研究所等大分子药物研究",
  "about-team3-exp1-t8": "组建开发团队，支撑了生物管线每年两到三个分子进入临床试验",

  "about-team4-txt1": "刘世洲 博士",
  "about-team4-txt4": "医学副总裁",
  "about-team4-exp1-t1": "1996年毕业于中国医科大学获得血液学硕士（七年制临床医学专业），又于2006年获得内科学博士学位",
  "about-team4-exp1-t2": "1996-2014 中国医科大学附属第一医院血液科及肿瘤内科任住院医，主治医及副教授，从事医疗工作",
  "about-team4-exp1-t3": "2014-2016 浙江大学转化医学研究院研究员",
  "about-team4-exp1-t4": "先后在丹麦癌症协会（2004-2006），美国哈佛大学医学院附属麻省总医院癌症中心（2007-2012）及英国皇家工程学院（2016）做访问学者或博士后研究",
  "about-team4-exp1-t5": "在Mol Cell、PNAS及MCB等期刊发表过多篇论文，并获取国家自然科学基金面上项目及浙大科研启动基金的资助",
  "about-team4-exp1-t6": "2016年进入工业界至今，曾先后于勃林格殷格翰任高级医学专家和项目负责人，强生任血液肿瘤临床研发部门负责人，冠科美博担任高级医学总监及英百瑞任首席医学官，参与多项产品临床开发计划制定，IND及NDA申报，领导I-III期临床试验，协助促成了阿法替尼及达雷妥尤单抗（兆珂）在中国的上市，并参与协助公司融资",
  "about-team4-exp1-t7": "2020年获得杭州市的C类人才认定",

  header: {
    home: '首页',
    aboutkl: '关于康霖',
    product: '研发与生产',
    patientZone: '患者专区',
    news: '新闻中心',
    enterprise: '企业与员工',
    expansion: '合作拓展'
  },
  gsxg:{
    dizhi:'杭州市钱塘区下沙街道福城路291号4-301',
    kanlinshengwu:"康霖生物",
    gongsi:'康霖生物科技',
    'gonsgi1':'康霖生物科技|关于康霖',
    'gonsgia':'康霖生物科技|研发与生产',
    'gonsgib':'康霖生物科技|新闻动态',
    'gonsgic':'康霖生物科技|企业与员工',
    'gonsgid':'康霖生物科技|加入我们',
    'gonsgie':'康霖生物科技|患者专区',
    'gonsgif':'康霖生物科技|新闻中心',
    'gonsgig':'康霖生物科技|新闻详情',
    'gonsgih':'康霖生物科技|合作拓展',
    'gonsgii':'康霖生物科技|联系我们',
    'gonsgig':'康霖生物科技|搜索',
    'gonsgij':'康霖生物科技|相关服务',
    'gonsgik':'康霖生物科技|公司介绍',
    'keywords':'康霖生物  吴昊泉 基因疗法  腺相关病毒  慢病毒  造血干细胞 地中海性贫血 帕金森病 血友病 艾滋病',
    'description':'康霖生物科技（杭州）有限公司是一家国家级高新技术企业，专注于创新基因药物研发。我们致力于解决严重影响人类健康的疾病，如艾滋病、帕金森病、血友病和地中海贫血症等。通过技术突破，为患者创造价值。了解更多关于我们的药物研发和临床试验成果，请访问康霖生物科技官网。',

  },
  seo: {
    home: {
      keywords: '康霖生物,基因治疗,功能性治愈,创新药物,杭州生物科技',
      description: '康霖生物科技（杭州）有限公司是一家国家级高新技术企业，专注于地中海贫血、帕金森病、血友病、艾滋病等疾病的创新基因药物研发。'
    },
    about: {
      keywords: '康霖生物关于我们,吴昊泉博士,基因治疗公司,杭州生物科技,公司介绍',
      description: '了解康霖生物科技 - 成立于2015年，致力于研发首创药物和同类最优的基因治疗创新药物。'
    },
    production: {
      keywords: '基因治疗平台,腺相关病毒载体,慢病毒,造血干细胞,药物研发,CMC',
      description: '探索康霖生物的基因治疗技术平台，包括腺相关病毒、慢病毒和造血干细胞平台，用于创新药物研发。'
    },
    prefecture: {
      keywords: '患者专区,患者安全,临床试验,基因治疗患者,康霖患者',
      description: '康霖生物患者专区 - 我们对患者安全的承诺，致力于提供可负担的基因治疗药物，倾听患者需求。'
    },
    news: {
      keywords: '康霖新闻,基因治疗新闻,生物科技新闻,公司动态,媒体报道',
      description: '康霖生物科技最新动态 - 公司新闻、媒体报道和基因治疗研究荣誉。'
    },
    enterprise: {
      keywords: '康霖招聘,生物科技工作,基因治疗职位,康霖企业文化,员工福利',
      description: '加入康霖生物科技 - 了解我们的企业文化、工作理念、福利激励和基因治疗领域的职业机会。'
    },
    join: {
      keywords: '康霖职位,生物科技招聘,基因治疗岗位,杭州生物科技工作',
      description: '查看康霖生物科技开放职位 - 加入我们的团队，推动基因治疗研究与开发。'
    },
    teamwork: {
      keywords: '康霖合作,科研合作,临床研究,生物科技合作伙伴',
      description: '与康霖生物科技合作 - 探索临床前研究、临床试验和学术合作机会。'
    },
    contact: {
      keywords: '联系康霖,康霖生物地址,杭州生物科技,商务合作',
      description: '联系康霖生物科技 - 商务咨询、合作洽谈或参观杭州总部。'
    }
  },


  common:{
    'yuedu':"阅读全文",
  },
  newsDetail:{
    'tuijian':'相关推荐',
  },
  news:{
    'gongsinew':'公司新闻',
    'meiti':'媒体报道',
    'rongyu':"荣誉专区",
    'videomiaoshu':'喜报！康霖自主研发的地中海贫血症创新基因治疗药物KL003取得重大突破，获央视等多家媒体报道',

  },
  prefecture:{
    'huanzheanquan':'患者安全',
    'huanzhegushi':'患者故事',
    'title':"我们牢记初心——“为患者做好药，创新造就价值”，康霖生物始终专注于基因治疗创新药物的研发；同时秉持着“做绝大部分患者用得起的好药”的理念，康霖生物也长期致力于降低基因治疗药物造价技术的研发，为基因治疗药物成为绝大部分患者用得起的好药奠定基础。从而为全球更多患者提供可及的可负担的创新疗法。我们从运输、物料、设备、生产、质量控制、质量保证、临床、环境健康安全等不同维度建立了质量管理体系，药品生产全过程可溯源。最大限度避免污染、交叉污染、混淆和差错，确保用药安全。",
    'one':'我们秉承初心，通过实地开展创新疗法的临床试验，让更多患者能够尽早参与疾病的治疗',
    'two':'我们步履坚定，降低成本，力争在治疗患者疾病的同时改善患者的生活质量',
    'three':'我们厚积薄发，让疗效佳、可及的、可负担的基因治疗药物尽早惠及有需要的患者',
    'four':'我们尊重差异，力争为患者提高多元和包容性',

    'title1':"从早期开发到临床用药，康霖生物非常重视受试者安全，因此在药物开发进程中的每一步都会充分考虑对患者的潜在影响，您的见解和观点可以增强我们对患者需求的认识。此外，康霖生物也致力于收集、监测、评估和报告康霖产品的安全性信息，当患者出现疑似不良事件时，请及时咨询专业医生，并通过电子邮件联系我们",
    'one1':'我们诚实、准确并有效地进行沟通',
    'two1':'我们体恤并倾听患者、医护人员和患者家庭的声音',
    'three1':'我们尊重医患关系',
    'four1':'我们让员工能够更多地融入和倾听患者群体',

  },
    'joingongzuozhize':'工作职责',
    'joingangweiyaoqiu':'岗位要求',
    'joingeshi':'投递格式：应聘岗位+姓名',
    'joinmore':'很多人加入康霖，是被公司愿景和情怀所打动的。为患者做好药，创新造就价值，这是康霖一贯秉承的发展理念。康霖人将以坚定不移的信念，深耕基因治疗领域，解决未被满足的临床需求，实现功能性治愈各类疾病的愿景。',
    'joinmore1':'公司始终坚持公开、竞争、择优的原则，从内外部选拔评聘各类优秀人才，努力构建与世界水平相适应的团队。',
    'joinmore2':'我们希望您，自信阳光、敢于担当，有创新意识，善于学习与总结，乐于交流与分享的合作精神，在每项工作中始终保持对结果负责任的态度。',


    "dev-btn-txt1": "技术平台",
  "dev-btn-txt2": "科学研发 ",
  "dev-btn-txt3": "生产与质量",
  "dev-banner-txt1": "基因治疗，",
  "dev-banner-txt2": "于无形处撰真章",

  "dev-part1-c1-txt1": "腺相关病毒",
  "dev-part1-c1-txt11": "载体平台",

  "dev-part1-c1-txt2": "全球知识产权，打通上下游技术",
  "dev-part1-c1-desc": "基于AAV载体，康霖生物以自有的全球知识产权为框架，积累多个上下游工艺开发专利技术，并且开发了多种靶向不同靶器官/靶组织的体细胞基因治疗创新疗法。技术面涵盖了载体设计、血清型筛选、AAV生产与纯化、体内外概念验证、生物分析方法开发等多个维度。",
  "dev-part1-c2-txt1": "慢病毒",
  "dev-part1-c2-txt2": "可满足大规模体内应用，全球领先",
  "dev-part1-c2-desc": "康霖生物多年技术累积所开发出的成熟的LV载体生产工艺，是世界上少数几个可以满足大规模体内应用的LV载体生产工艺，兼具放大能力和优秀的质量指标，结合康霖技术领先的细胞基因编辑和载体基因表达调控技术，开发及协助开发了包含CAR-T疗法在内的多种细胞与基因治疗在研产品。",
  "dev-part1-c3-txt1": "造血干细胞",
  "dev-part1-c3-txt11": "平台",

  "dev-part1-c3-txt2": "优化工艺，降低载体用量，维持细胞干性",
  "dev-part1-c3-desc": "通过造血干细胞慢病毒转导工艺优化，将慢病毒载体用量降低了10倍，极大程度降低成本。动物体内实验证明改造后的造血干细胞植入能力与未改造造血干细胞相比无显著差异，仍然维持了良好的干性。回输患者后的植入时间显著优于同类产品。",

  "dev-part2-txt1-title-1": "研发",
  "dev-part2-txt1-title-2": "管线",
  "dev-part2-txt1": "聚焦领域",
  "dev-part2-c1-count1": "60",
  "dev-part2-c1-unit1": "亿",
  "dev-part2-c1-count2": "50",
  "dev-part2-c1-unit2": "万",
  "dev-part2-c1-txt1": "地中海贫血",
  "dev-part2-c1-txt2": "中国地区",
  "dev-part2-c1-txt21": "年均治疗费用",
  "dev-part2-c1-txt3": "全球重度",
  "dev-part2-c1-txt31": "地中海贫血症患者",

  "dev-part2-c1-txt4": "地中海贫血症",
  "dev-part2-c1-txt5": " 地中海贫血（β-珠蛋白生成障碍性贫血），又被称为海洋性贫血，是一种遗传性溶血性贫血疾病。该疾病由于遗传基因缺陷引起，导致血红蛋白中的一种或多种珠蛋白链合成缺乏或不足，进而引发贫血或病理状态。地中海贫血症患者治疗目前主要有两种选择，一是输血替代治疗，即终生输血和使用去铁剂，成人的年均治疗费用8-10万元，但这些方法无法根治该疾病并且有较多严重后遗症；二是移植治疗，即通过造血干细胞移植、脐带血移植进行治疗，人均医疗费用40万元左右，移植治疗是目前主要的根治方法，但该方法难以寻找到相同的配型，仅有少部分患者能获得移植，并且患者有产生移植物抗宿主病（GvHD）的风险，需要终身服用抗排异药物。",
  

  "dev-part2-c2-count1": "850",
  "dev-part2-c2-unit1": "万",
  "dev-part2-c2-count2": "300",
  "dev-part2-c2-unit2": "万",
  "dev-part2-c2-txt1": "帕金森病",
  "dev-part2-c2-txt2": "全球患者",
  "dev-part2-c2-txt3": "中国患者",
  "dev-part2-c2-txt4": "帕金森病",
  "dev-part2-c2-txt5": " 帕金森病又称震颤麻痹症，是一种神经系统功能障碍性疾病。该疾病主要由于大脑黑质神经元的大量变性和死亡，导致多巴胺缺乏，从而出现肌肉僵硬、震颤、运动缓慢以及平衡和协调障碍等症状。帕金森病目前主要治疗方案包括药物治疗、手术治疗以及康复训练等。其中药物治疗主要通过增加多巴胺水平来改善运动功能，并减轻其他相关问题（如抑郁、失眠等），但也存在较多的副作用；手术治疗包括脑立体定向微创导航术、脑深部电刺激术（deep brain stimulation,DBS）等，虽然可以明显改善运动症状，但并不能根治疾病，术后仍需应用药物治疗；康复训练则是根据不同的行动障碍进行相应的康复或运动训练，提高患者的日常生活技能和改善心理健康状态。",
  
  "dev-part2-c3-count11": "≈28",
  "dev-part2-c3-unit1": "万",
  "dev-part2-c3-count2": "6.5-13",
  "dev-part2-c3-unit2": "万",
  "dev-part2-c3-txt1": "血友病",
  "dev-part2-c3-txt2": "全球重症患者",
  "dev-part2-c3-txt3": "中国患者",
  "dev-part2-c3-txt4": "血友病",
  "dev-part2-c3-txt5": " 血友病，是一种遗传性凝血功能缺陷疾病，主要由于凝血因子的缺乏或功能异常引起。血友病可分为三种型别，包括A型血友病(缺乏凝血因子VIII)和B型血友病(缺乏凝血因子IX)以及C型血友病(缺乏凝血因子XI)，该疾病主要表现为患者易出血或不易止血，目前主要的治疗方法为补充凝血因子来控制出血，但患者每周需要进行多次注射，并且即使注射药物后，还是会出现出血情况，患者生活质量较差。",

  "dev-part2-c4-count1": "3840",
  "dev-part2-c4-unit1": "万",
  "dev-part2-c4-count2": "114.8",
  "dev-part2-c4-unit2": "万",
  "dev-part2-c4-txt1": "艾滋病",
  "dev-part2-c4-txt2-1": "截止2021年底",
  "dev-part2-c4-txt2": "截止2021年底全球艾滋病感染者",
  "dev-part2-c4-txt3": "截止2021年底中国艾滋病感染者",
  "dev-part2-c4-txt4": "艾滋病",
  "dev-part2-c4-txt5": " 艾滋病，是由人类免疫缺陷病毒（HIV）感染引起的慢性病毒性疾病。HIV感染会损害人体免疫系统，导致免疫功能受损，进而使患者容易受到感染和疾病的侵袭。艾滋病的特征性症状包括免疫系统衰竭、机体易感染和恶性肿瘤的发生。虽然对于艾滋病治疗投入了大量的资源研究，但医学界目前没有任何可以治愈艾滋病的方法，也没有可行的疫苗，大部分的治疗方法都只能减慢或抑制病毒在体内的扩散。目前比较常见的治疗方法有鸡尾酒疗法，但该疗法仍然有明显的局限性，例如容易产生耐药性、患者需要长时间服药以及会产生严重的副作用等。",

  "dev-part2-pipe-txt2": "康霖生物立足创新，坚持患者导向，重点布局艾滋病、帕金森、地贫、血友病等严重影响人类健康的疾病领域，研发了多个具有自主知识产权的创新基因治疗药物",
  "dev-part2-btn-text": "点击查看完整大图",
  "shiyingzheng":"适应症",
  "zaoqiyanjjiu":"早期研究",
  "linchuangqianyanjiu":"临床前研究",
  "linchuangpopc":'临床POC',
  "xinyaolinchuangshenqing":"新药临床申请",
  "linchangyanjiu":"临床研究",
  "weipilouxiangmu":"未披露项目",
  "dev-part3-txt-title": "生产与质量",
  "dev-part3-txt1": "CMC职责",
  "dev-part3-txt2": "CMC部将配合公司各类项目的整体推进计划，在细胞水平、动物试验、IIT、IND、NDA等药物研发的不同阶段，制定最优的CMC研究和生产策略。通过病毒载体开发平台，制备候选药物进行分子筛选，快速完成药物研发的前期开发工作。与此同时，进行基础路线的药学研究工作，分阶段进行药学研究及样品生产工作。未来将以平台工艺为基础，提供高质量的产品来满足各类基因治疗药物的临床开发与商业化生产等不同阶段。",
  "dev-part3-txt3": "CMC开发过程",
  "dev-part3-txt4": "在康霖，基因治疗药物的生产工艺极具优势，涵盖了工艺开发、质量检测、质量保证等方面。我们熟知合规性和科学性是工艺开发与药品生产中的两大指导方针。科学性是工艺稳定的基础。在遵循“质量源于设计（QbD）”理念的过程中，首先确定目标产品的质量概况 (QTPP)，其中包括药品的安全性、有效性及临床给药方式等信息。然后根据QTPP进行质量属性评估，从而确定产品的关键质量属性(CQA)以及表征产品所需的产品质量。为了确保满足CQA，基于工艺知识确立特定的设计空间，进一步确定关键工艺参数（CPP）以及关键物料属性（CMA）。为保证各CPP和CMA始终处于各自的设计或控制范围内，制定相对应的控制与测试策略以及明确所需的监测与控制水平，以保证整体工艺实现QTPP所涉及的目标产品质量标准。",

  "dev-part3-s1-t1": "目标产品质量概况",
  "dev-part3-s1-txt1": "分析工艺及非临床数据",
  "dev-part3-s1-txt2": "结合现有基础工艺研究数据",
  "dev-part3-s1-txt3": "治疗策略",
  "dev-part3-s2-t1": "质量属性评估",
  "dev-part3-s2-txt1": "采用已有数据及工艺认知",
  "dev-part3-s2-txt2": "预先危险分析（PHA）",
  "dev-part3-s2-txt3": "确定 CQA ",
  "dev-part3-s3-t1": "设计空间",
  "dev-part3-s3-txt1": "工艺流程图",
  "dev-part3-s3-txt2": "基于工艺开发经验",
  "dev-part3-s3-txt3": "失效模型效应分析（FMEA） ",
  "dev-part3-s4-t1": "确定控制策略",
  "dev-part3-s4-txt1": "根据实验结果调整工艺",
  "dev-part3-s4-txt2": "实验设计（DoE）",
  "dev-part3-s4-txt3": "确定 CPP",
  "dev-part3-s5-t1": "管理产品生命周期",
  "dev-part3-s5-txt1": "设施设备管理",
  "dev-part3-s5-txt2": "工艺稳健性研究",

  "dev-part3-card-txt1": "工艺平台",
  "dev-part3-card-txt2": "我们已建立了高效且完善的病毒载体开发平台，能满足公司内部早期药物发现过程。我们的平台具备出众的病毒载体小试、中试生产能力，能有效缩短从候选分子到 IND 申报的周期。我们的开发平台具备以下能力：",
  "dev-part3-card-l-txt1": "有效评估病毒载体的成药性",
  "dev-part3-card-l-txt2": "多通量小批量制备样品，筛选早期分子结构",
  "dev-part3-card-l-txt3": "通用的菌毒株库，降低开发成本，快速推进项目",

  "dev-part3-card2-txt1": "质量控制",
  "dev-part3-card2-txt2": "检测方法的开发和验证符合Ch.P、USP、EP及ICH等有关指南要求。质量控制涉及原辅料、公用系统、中间产品和成品，执行生产全流程质量控制。",
  "dev-part3-card2-txt3": "质量体系",
  "dev-part3-card2-txt4": "已搭建按照 GMP与ICH 指南Q8/Q9/Q10为核心的质量体系，并通过了ISO质量体系认证。公司贯彻全生命周期的质量管理，为CMC工作开展以及患者用药的安全有效提供了保障。",

  "patient-btn-txt1": "患者安全",
  "patient-btn-txt2": "患者故事 ",
  "patient-sub-btn-txt1": "我们承诺",
  "patient-sub-btn-txt2": "我们倾听",
  "patient-s-txt1": "我们牢记初心——“为患者做好药，创新造就价值”，康霖生物始终专注于基因治疗创新药物的研发；同时秉持着“做绝大部分患者用得起的好药”的理念，康霖生物也长期致力于降低基因治疗药物造价技术的研发，为基因治疗药物成为绝大部分患者用得起的好药奠定基础。从而为全球更多患者提供可及的可负担的创新疗法。我们从运输、物料、设备、生产、质量控制、质量保证、临床、环境健康安全等不同维度建立了质量管理体系，药品生产全过程可溯源。最大限度避免污染、交叉污染、混淆和差错，确保用药安全。 ",
  "patient-s1-txt1": "我们秉承初心，通过实地开展创新疗法的临床试验，让更多患者能够尽早参与疾病的治疗 ",
  "patient-s1-txt2": "多通量小批量制备样品，我们步履坚定，降低成本，力争在治疗患者疾病的同时改善患者的生活质量 ",
  "patient-s1-txt3": "我们厚积薄发，让疗效佳、可及的、可负担的基因治疗药物尽早惠及有需要的患者 ",
  "patient-s1-txt4": "我们尊重差异，力争为患者提高多元和包容性 ",

  "patient-s-txt2": "从早期开发到临床用药，康霖生物非常重视受试者安全，因此在药物开发进程中的每一步都会充分考虑对患者的潜在影响，您的见解和观点可以增强我们对患者需求的认识。此外，康霖生物也致力于收集、监测、评估和报告康霖产品的安全性信息，当患者出现疑似不良事件时，请及时咨询专业医生，并通过电子邮件联系我们",
  "patient-s2-txt1": "我们诚实、准确并有效地进行沟通 ",
  "patient-s2-txt2": "我们体恤并倾听患者、医护人员和患者家庭的声音",
  "patient-s2-txt3": "我们尊重医患关系",
  "patient-s2-txt4": "我们让员工能够更多地融入和倾听患者群体",

  "culture-banner-txt1": "志同道合",
  "culture-banner-txt2": "扣响基因治疗的时代之门",
  "culture-btn-txt1": "企业文化",
  "culture-btn-txt2": "工作理念",
  "culture-btn-txt3": "福利激励",
  "culture-btn-txt4": "加入康霖",
  "culture-btn-txt5": "团队风采",
  "culture-part1-t1": "我们的使命",
  "culture-part1-txt1": "为患者做好药、创新造就价值",
  "culture-part1-t2": "我们的愿景",
  "culture-part1-txt2": "致力于为全球患者提供安全可及的创新基因治疗药物，打造一家总部在中国的跨国制药企业。",
  "culture-part1-t3": "我们的价值观",
  "culture-part1-txt3": "以人为本、勇于创新、追求卓越、值得信赖",
  "culture-part2-t1": "创新",
  "culture-part2-txt1": "改变未来，也改变我们回望历史的视线",
  "culture-part2-t2": "包容",
  "culture-part2-txt2": "多元，迸发非凡；融合，孕育创想",
  "culture-part2-t3": "精进",
  "culture-part2-txt3": "知也无崖，思也无崖，生命不息，攀登不止",

  "culture-part3-t1": "福利与关爱",
  "culture-part3-t2": "奖励激励",
  "culture-part3-t3": "员工持股",
  "culture-part3-txt1": "我们倡导员工工作和生活的平衡，高度重视员工的身体健康。不仅为员工的职业发展提供支持，建立富有竞争力的整体薪酬体系，还为员工提供多种健康福利。",
 
  "culture-part3-t1-i1": "社会保险",
  "culture-part3-t1-i2": "公积金",
  "culture-part3-t1-i3": "商业保险",
  "culture-part3-t1-i4": "年度体检",

  "culture-part3-t1-i5": "弹性上下班制",
  "culture-part3-t1-i6": "超级年假",
  "culture-part3-t1-i7": "节日活动",
  "culture-part3-t1-i8": "公司食堂",

  "culture-part3-t1-i9": "暖心福利",
  "culture-part3-t1-i10": "团建基金",
  "culture-part3-t1-i11": "俱乐部",

  "culture-part3-txt2-1": "我们以提高薪酬、带薪休假、创造多元化职业发展通道等多种方式奖励激励员工，开展评选季度先进，年度优秀，年度新人，董事长特别奖等多种奖项，加大精神激励和物质奖励力度。我们搭建全方位、多维度的人才发展平台，建立健全相应的制度体系，按照项目团队成员贡献程度不同给予重奖，调动项目团队攻坚克难的积极性。",
  "culture-part3-txt3": "公司提倡全员持股，入司后满足条件的员工可按估价购买一定比例的股权，成为公司的股东并分享股利。",

  "culture-part4-txt1": "人生最幸福的事情就是和一群志同道合的朋友，在最该努力的年纪，为同一个梦想努力拼搏，充分实现自我价值。",

  "join-banner-txt1": "企业与员工",
  "join-banner-txt2": "职位招聘",
  "join-post-txt1": "我们正在寻找闪闪发光的你!",
  "join-post-h1-t1": "简历投递：",
  "join-post-h1-t2": "投递格式：应聘岗位+姓名",
  "join-post-h1-t3": "人力资源部：",
  "join-post-h1-t4": "联系人：吴女士 ",
  "join-post-h1-t5": "联系电话：",
  "join-post-h1-t6": "公司地址：杭州市钱塘区下沙街道福城路291号4-301",
  "join-part1-txt1": "从早期开发到临床用药，康霖生物非常重视受试者安全，因此在药物开发进程中的每一步都会充分考虑对患者的潜在影响，您的见解和观点可以增强我们对患者需求的认识。此外，康霖生物也致力于收集、监测、评估和报告康霖产品的安全性信息，当患者出现疑似不良事件时，请及时咨询专业医生，并通过电子邮件联系我们。",
  "join-part1-txt2": "公司始终坚持公开、竞争、择优的原则，从内外部选拔评聘各类优秀人才，努力构建与世界水平相适应的团队。",
  "join-part1-txt3": "我们希望您，自信阳光、敢于担当，有创新意识，善于学习与总结，乐于交流与分享的合作精神，在每项工作中始终保持对结果负责任的态度。",

  "contact-banner-txt1": "联系我们",
  "contact-btn-txt1": "合作洽谈 ",
  "contact-btn-txt2": "联系我们",
  "contact-part1-c1-txt1": "临床前研究",
  "contact-part1-c1-txt2": "康霖生物与国内多家非临床药效/毒理研究机构，如上海药明康德、北京协和建昊、成都华西海圻、浙江大学药物安全评价研究中心等保持着长期良好的合作关系。通过整合诸多业内优秀资源，我们目前在多个项目的临床前研究中获得了丰富的动物药效和安评数据。",

  "contact-part1-c2-txt1": "临床研究",
  "contact-part1-c2-txt2": "为确保高质量高水平的研究，我们从患者资源、医疗水平、招募能力、骨髓移植水平、GCP资质等多方面考虑，甄选了国内实力强大的临床研究单位，例如复旦大学附属上海公共卫生中心、北京佑安医院等，建立了良好的合作关系，开展了研究者发起的临床试验。在临床试验监察、项目管理、数据管理、统计和分析方面，我们也聘请了第三方CRO公司，来保障临床试验的过程顺利和质量可靠性。",

  "contact-part1-c3-txt1": "专利与知识产权外部合作机构 ",
  "contact-part1-c3-txt2": "康霖生物以创新研发为主线，致力于一类新药的自主研发。在研发和临床试验过程中，需对自主知识产权进行国内与国际的申请与保护，已与多家专利事务所与机构建立了长久的合作。",
  "contact-part1-c4-txt1": "高校与科研机构",
  "contact-part1-c4-txt2": "康霖生物已经与浙江大学，复旦大学，杭州师范大学，浙江中医药大学，浙江工业大学等国内多所高校展开合作与交流。2020年公司浙江省博士后工作站获批设立，目前与浙江工业大学流动站签订合作协议，联合培养博士后，已有2位博士进站。",

  "contact-part1-p-txt1": "合作需求",
  "contact-part1-p-txt2": "在康霖生物，我们致力于开发创新基因治疗药物，以挽救更多的生命，目前，我们在以下领域的基因治疗药物临床研究方面寻找战略合作伙伴：",
  "contact-part1-p-i1": "传染病",
  "contact-part1-p-i2": "神经退行性疾病",
  "contact-part1-p-i3": "单基因遗传病 ",
  "contact-part1-p-i4": "眼科",
  "contact-part1-p-i5": "血液病",
  "contact-part1-p-txt3": "业务洽谈",
  "contact-part1-p-txt4": "周女士",
  "contact-part1-p-txt5": "康霖生物科技（杭州）有限公司",
  "contact-part1-p-txt6": "杭州市钱塘区下沙街道福城路291号4-301",
  "contact-part1-p-txt7": "查看地图",
  "news-btn-txt1": "公司新闻",
  "news-btn-txt2": "媒体报道",
  "news-btn-txt3": "荣誉专区",
  "news-video-txt": "喜报！康霖自主研发的地中海贫血症创新基因治疗药物KL003取得重大突破，获央视等多家媒体报道",
  "footer-txt1": "杭州市钱塘区下沙街道福城路291号4-301",
  "footer-txt2": "康霖生物科技（杭州）有限公司 ",
  "footer-txt3": " 浙ICP备2022003670号-1",
  "prefecturename":'生命不可等待，基因永远诚实',
  "xinwenname":'新闻中心',
  "xiangguantuijian":"相关推荐",
  "gongsidizhi":"公司地址",
  "sousuojieguo":'搜索结果',
  'sousuobtn':'搜索',
  "about-icon-txt2": "基因治疗",
  "peoplehuyin":"华音",
  "peoplehuyin1":"能够加入康霖从事科研，我感到无比荣幸。康霖为员工营造的和谐、向上的氛围令我感到开心；康霖对待科学，严谨务实，专注创新的的态度令我感到自豪；康霖对于科研思想的传承和对生命的尊重令我深受感动。",
  "peoplechenxi":'晨曦',
  "peoplechenxi1":'从16年初入职实验研发人员，从最基础的质粒载体构建以及构建单克隆细胞到开始接触慢病毒生产，从最开始的小白到最后随着实验的熟练程度可以得到高滴度的慢病毒载体；后转岗至质量岗位，从质控零经验零基础开始慢慢积累，到现在可以有一套成熟的质控标准，且达到行业领先的水平。一路走来感谢有位亦师亦友的老板，给我职场道路上的帮助；感谢部门老大带来一套合规的理念，带给我思想的转变；感谢公司各位小伙伴对我的互帮互助。康霖生物给了我足够的时间和空间来慢慢成长，希望在以后的时间里我可以陪伴康霖变大、变强，陪同它走向巅峰的时刻。',
  "peoplepingguo":'苹果派',
  "peoplepingguo1":'自2022年初加入康霖研发部，在这一年多以来，我从研发小白到现在能够很好的完成研发任务，期间每一次的进步都让我倍受鼓舞。在工作中，融洽和谐的团队氛围、科学严谨的研发过程、高效热烈的讨论交流让我感觉非常幸运有机会加入康霖，感谢公司给与了我们充分展示自身价值的平台和无限的职业前景。',
  "peoplepxiaofanqie":'小番茄',
  "peoplepxiaofanqie1":'从2019年6月毕业后就入职了研发部，已经快4年了。所谓隔行如隔山，虽然我也是生物学出身，但是基因治疗领域对我来说就是一个崭新的世界。因此，刚入实验室时，还需要老同事手把手教各种实验方法技术以及实验设计思路。在那时候也接触了许多正在研发中的项目，学习到了很多。随着时间的推移，在自我学习及同事的指导与帮助下，我也成长到能承担一个项目的研发工作了。我很幸运能在这样一个互帮互助，共同努力的公司中成长进步！',
  "peoplepingguoxuxu":'徐徐图之',
  "peoplepingguoxuxu1":'毕业至今已从事微生物发酵领域7年时间。自从加入康霖团队以来，康霖的管理使我对GMP体系下工艺研究、文件管理、数据可靠性等方面有了更加深刻的认知。感谢公司为我们提供了良好的成长平台。同时我也见证了康霖生物在各个方面发展迅猛、愈加完善。',
  "peoplepingguofeifei":'飞飞飞',
  "peoplepingguofeifei1":'回想刚入职时，还需要在老同事的带领下做零散的小事，比如提质粒,构建载体等，但是后来就能独自设计实验推进项目了。一路上遇到过挫折，也获得了成长，也很珍惜那些既是同事又是朋友们的陪伴。我觉得自己很幸运，一毕业就能遇到康霖这样有温度的公司。',
  "peoplepingguoxiangd":'香丁啊',
  "peoplepingguoxiangd1":' 学校出来便进入康霖大家庭，至今已过三年，一直在造血干细胞的质量检测方面深耕。从一无所知的小白到现在能独立完成，并负责整个流程的检测，让我收获颇多。当2021年两例重症患者经治疗后摆脱疾病，可以如正常人的生活，2个家庭获得新生之时，让我真正意识到自己参与的项目是多少有意义的事情。康霖大家庭是个有温度的企业，有着温馨的工作氛围，同事热情友好，相处融洽。并拥有各项经验丰富的专业人士。很幸运加入到康霖，给予了成长的平台，努力前进的方向！祝公司持续创新，蓬勃发展，日胜一日！',
  "peoplepingguored":'Redone',
  "peoplepingguored1":'大学毕业后加入康霖的细胞工艺开发团队，开展小试与中试的病毒包装工作。在康霖这个充满朝气且极具创造力的团队里，在公司领导、同事的鼓励与支持下，个人工作能力得到迅速成长与积累。非常幸运地加入了康霖这个更加先进与广阔的平台，继续从事BEVS在CGT领域的应用与研究。未来跟随康霖前行，努力为团队创造更高价值，将个人成长融入并贡献于康霖的发展。',
  "peoplepingguoxuwq":'雪倩',
  "peoplepingguoxuwq1":'2022年加入康霖这个有爱的大家庭，初来乍到公司满满的正能量及优秀的企业文化让我倍感欣慰，我是行政部的一员，感恩公司提供优越的平台让我在此愉悦的施展自己的才能，虽然工作繁琐，但是我愿意用心去把它做的更好，扬长补短，未来我将继续心存感激，恪尽职守把工作放在第一位和公司共同成长，为公司的发展创造更多价值，祝愿公司未来蓬勃发展，再创辉煌。',



}




// WEBPACK FOOTER //
// ./src/lang/zn.js